import React from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";

import Button from "@mui/material/Button";

import SearchIcon from "@mui/icons-material/Search";

import CloseButton from "components/buttons/CloseButton/CloseButton.component";
import Label from "components/typographies/Label/Label.component";

// Helpers
import {
  removeQueryOrSlugItem,
  replaceSlugAndQuery,
} from "helpers/inventory-filters";
import useInventoryFilters from "hooks/inventory/useInventoryFilters.hook";

// Styles
import { useStyles } from "./MakeModelButton.styles";

const MakeModelButton = ({ onClick, clearInventoryCards }) => {
  const router = useRouter();
  const { filters: inventoryFilters } = useInventoryFilters();
  const make = inventoryFilters?.make[0];
  const model = inventoryFilters?.model[0];

  const classes = useStyles({ make, model });

  const handleClick = (e) => {
    if (make[0]) {
      clearInventoryCards();
      const { newQuery, newSlug } = removeQueryOrSlugItem(router.query, {
        key: "make",
        value: make,
      });
      replaceSlugAndQuery(router, newSlug, newQuery);
    }
    // this is to stop click propagation to the button underneath
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <div className={classes.buttonContainer}>
      <Button
        onClick={onClick}
        className={classes.button}
        variant="contained"
        data-cy="make-model-button"
      >
        <SearchIcon color="primary" />
        <span className={classes.makeModelContainer}>
          <Label size="lg" className={classes.makeText}>
            {make || "Any make"}
          </Label>{" "}
          <span className={classes.middleDot}>•</span>{" "}
          <Label size="lg" className={classes.modelText}>
            {model || "Any model"}
          </Label>
        </span>
        {/* Ghost item to balance flex layout. Same size as clear icon. */}
        <span className={classes.ghostItem} />
      </Button>
      <span className={classes.clearButton}>
        {make && <CloseButton onClick={handleClick} />}
      </span>
    </div>
  );
};

MakeModelButton.propTypes = {
  onClick: PropTypes.func,
};

MakeModelButton.defaultProps = {
  onClick: () => {},
};

export default MakeModelButton;
